import React from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Outlet, useLocation } from "react-router-dom";

const AdminLayout = () => {
  const location = useLocation();

  const hideSidebarRoutes = [
    "/points-wallet",
    "/portfolio-summary",
    "/profile",
    // "/profile-point-wallet",
    "/deal-saved",
    "/card-select",
    "/results",
    "/deals-details"
  ];

  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);

  return (
    <div className="flex min-h-screen bg-[#F5F7FB] dark:bg-slate-900 transition-colors duration-300">
      
      {!shouldHideSidebar && <AdminSidebar />}

      <div className="flex-1 flex flex-col min-h-screen">
        
        <AdminHeader />

        <main
          className={`flex-1 overflow-y-auto ${
            shouldHideSidebar
              ? "p-0"
              : "p-4 md:p-6 lg:p-8 pb-20"
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;